import { useMediaQuery } from 'usehooks-ts'

export function useIsMobile(breakpoint = 1024) {
  return useMediaQuery(`(max-width: ${breakpoint - 1}px)`)
}
